module.exports = __webpack_public_path__ + "img/rank_more05.fc4c7023.png";